import React, { ChangeEvent } from 'react'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import styles from './styles.module.css'

export enum ServiceType {
  BOTH = 'both',
  INSTALLATIONS_ONLY = 'installations_only',
  DELIVERIES_ONLY = 'deliveries_only',
}

interface ServiceTypeDropdownProps {
  value: ServiceType
  onChange: (value: ServiceType) => void
  disabled?: boolean
  fullWidth?: boolean
  required?: boolean
}

export default function ServiceTypeDropdown({
  value,
  onChange,
  disabled = false,
  fullWidth = false,
  required = false,
}: ServiceTypeDropdownProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value as ServiceType)
  }

  const options = [
    { value: ServiceType.BOTH, label: 'Installations & Deliveries' },
    { value: ServiceType.INSTALLATIONS_ONLY, label: 'Installations Only' },
    { value: ServiceType.DELIVERIES_ONLY, label: 'Deliveries Only' },
  ]

  return (
    <TextField
      className={styles.dropDownSelect}
      label="Service Type"
      select
      fullWidth={fullWidth}
      name="serviceType"
      disabled={disabled}
      onChange={handleChange}
      value={value}
      required={required}
      SelectProps={{
        MenuProps: {
          PaperProps: {
            style: {
              maxHeight: 400,
              width: 250,
              fontFamily: '',
            },
          },
        },
      }}
    >
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          className={styles.dropDownOption}
        >
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  )
}